import { CountryDto } from '../responses/CountryDto'
import { Country } from '../../../core/models/entities/Country'

export function mapToCountry(dto: CountryDto): Country {
  return { ...dto }
}
